const STORAGE_PREFIX = "appSearchFilters";
const buildKey = (key) => `${STORAGE_PREFIX}:${key}`;

export const encodeFilters = (filters = {}) => {
  return JSON.stringify(filters, (_key, value) =>
    value === undefined ? undefined : value,
  );
};

export const decodeFilters = (encoded) => {
  if (!encoded) return null;

  try {
    return JSON.parse(encoded);
  } catch (err) {
    return null;
  }
};

export const saveFiltersToLocalStore = (key, filters) => {
  try {
    const encoded = encodeFilters(filters);
    localStorage.setItem(buildKey(key), encoded);
  } catch (err) {
    console.error("Failed to save filters to localStorage", err);
  }
};

export const loadFiltersFromLocalStore = (key, defaultValue = null) => {
  try {
    const stored = localStorage.getItem(buildKey(key));
    const decoded = decodeFilters(stored);

    return decoded ?? defaultValue;
  } catch (err) {
    console.error("Failed to load filters from localStorage", err);
    return defaultValue;
  }
};

export const clearFiltersFromLocalStore = (key) => {
  localStorage.removeItem(buildKey(key));
};
